module.exports = __webpack_public_path__ + "img/meeting.988c592b.png";